module.exports = __webpack_public_path__ + "img/carbon-tokens.029ddcc9.svg";